import Cookies from 'js-cookie';

const TOKEN_KEY = 'authorization.token';

const partnerAuthorization = {
    isAuthorized: (): boolean => Cookies.get(TOKEN_KEY) !== undefined,
};

export default partnerAuthorization;
